import React from 'react';
import _ from 'lodash';
import sizedImage from '../../../../utils/imageHelper';

const CancelDayPopup = props => {
  const { booking, title, fetchBookingDetails, customMessage } = props;
  const id = _.get(booking, 'id', null);
  const location = _.get(booking, 'office.name', null);

  return (
    <div className="cancelBooking">
      <div onClick={props.onCancelAction} className="modal-close-button" />
      <div className="bookedOffice-popup-title">{title}</div>
      <div className="cancelBooking-warning" dangerouslySetInnerHTML={{ __html: customMessage }} />
      <div className="cancelBooking-actions">
        <button
          style={{ marginLeft: '0' }}
          className="cancelBooking-blockButton secondary-button"
          onClick={() => {
            props
              .onAction(id, props.day)
              .then(response => {
                props.setToastMessage(props.successMessage);
              })
              .catch((response = {}) => {
                props.setToastMessage(response);
              })
              .finally(() => {
                fetchBookingDetails(id);
              });
            props.onCancelAction();
          }}
        >
          {props.submitButtonText}
        </button>
        <button
          style={{ marginLeft: '0' }}
          className="cancelBooking-cancelButton bookedOffice-submitButton main-button"
          onClick={props.onCancelAction}
        >
          {props.cancelButtonText}
        </button>
      </div>
    </div>
  );
};
export default CancelDayPopup;
